import * as React from 'react';
import { SVGProps } from 'react';

const IconSlideSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 2H5v12h2V2Zm4 0H9v12h2V2Z"
    />
  </svg>
);
export default IconSlideSizeS;
